import { render } from "./A5.vue?vue&type=template&id=0a7dd2a7&scoped=true"
import script from "./A5.vue?vue&type=script&lang=js"
export * from "./A5.vue?vue&type=script&lang=js"

import "./A5.vue?vue&type=style&index=0&id=0a7dd2a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7dd2a7"]])

export default __exports__